import React from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';

class BucketOptionsModal extends React.Component {
    onDelete = () => {
        this.props.onDeleteBucket(this.props.bucket.id);
    };

    render() {
        const { classes } = this.props;

        if (!this.props.show) {
            return null;
        }

        return (
            <div className={classes.modal}>
                <div
                    className={classes.backdropStyle}
                    onClick={this.props.onClose}
                />
                <div className={classes.modalStyle}>
                    <div className={classes.controlButtons}>
                        <button onClick={this.props.onEditBucket}>
                            <img alt="edit" src="/assets/edit_icon.svg" />
                            <span>Edit</span>
                        </button>
                        {/*<button onClick={this.onDelete}>*/}
                        {/*    <img alt="delete" src="/assets/delete_icon.svg" />*/}
                        {/*    <span>Delete</span>*/}
                        {/*</button>*/}
                    </div>
                </div>
            </div>
        );
    }
}

BucketOptionsModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    onDeleteBucket: PropTypes.func.isRequired,
    onEditBucket: PropTypes.func.isRequired,
    bucket: PropTypes.object.isRequired,
    show: PropTypes.bool,
};

const style = ({ palette, typography }) => ({
    modal: {
        width: 0,
        height: 0,
    },
    controlButtons: {
        display: 'flex',
        flexDirection: 'column',
        '& button': {
            outline: 'none',
            borderRadius: '4px',
            border: 'none',
            height: '36px',
            textAlign: 'start',
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            font: 'inherit',
            fontSize: typography.caption.fontSize,
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: palette.background.gray1Color,
            },
        },
        // '& > :last-child': {
        //     color: 'red',
        //     borderTop: `1px solid ${palette.separator.main}`,
        // },
        '& img': {
            padding: '12px',
        },
    },
    backdropStyle: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 128,
    },
    modalStyle: {
        backgroundColor: 'white',
        width: '140px',
        height: 'auto',
        position: 'relative',
        left: '-30px',
        bottom: '36px',
        zIndex: '128',
        borderRadius: '4px',
        boxShadow: '0 0 8px 0 rgba(0,0,0,0.12), 0 8px 8px 0 rgba(0,0,0,0.08)',
    },
});

export default injectSheet(style)(BucketOptionsModal);



// WEBPACK FOOTER //
// ./src/components/modals/BucketOptionsModal.js